import * as React from "react";
import { useSelector } from "react-redux";

import { selectPortableMode } from "../App/selectors";

import FullScreenStats from "./containers/FullScreenStats/FullScreenStats";
import PortableLayout from "./containers/PortableLayout/PortableLayout";

import { useAuth } from "../../hooks/useAuth";

const StatPage = React.memo(() => {
  useAuth();

  const portableMode = useSelector(selectPortableMode);

  if (portableMode) {
    return <PortableLayout />;
  }

  return <FullScreenStats />;
});

export default StatPage;
